import { apiFetch } from '../config/api'

export interface FeedbackPayload {
  category: 'bug' | 'expectation_mismatch' | 'suggestion' | 'other'
  expected: string
  actual?: string
  improvement?: string
  severity?: 'minor' | 'moderate' | 'major'
  context: {
    page_route: string
    page_title: string
    user_agent: string
    viewport: string
    is_mobile: boolean
    timestamp: string
    page_context?: Record<string, unknown>
  }
}

export async function submitFeedback(
  payload: FeedbackPayload,
): Promise<{ success: boolean; id?: number }> {
  const res = await apiFetch('/api/feedback', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(`Feedback submission failed: ${res.status}`)
  return res.json()
}
